import type { CustomAttributeValues } from "@jti/fe-common";
import { CasCustomAttrsApi } from "@jti/rest-api";
import type { CustomAttributeWriteResponse } from "@jti/rest-api-types";

import type { ProfileApiBuilder } from "../profileApiSlice.types";
import { handleProfileApiError } from "../utils/handleProfileApiError";

export const updateCustomAttributesEndpoint = (builder: ProfileApiBuilder) => ({
  updateCustomAttributes: builder.mutation<CustomAttributeWriteResponse, CustomAttributeValues>({
    queryFn: async (attributes) => {
      const casCustomAttrsApi = CasCustomAttrsApi.init();

      try {
        const response = await casCustomAttrsApi.write(attributes);
        return { data: response };
      } catch (error: unknown) {
        return handleProfileApiError(error);
      }
    },
  }),
});
